import { Button, Tooltip, TooltipProps } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const styles = {
  CustomInputTooltip: {
    verticalAlign: "bottom",
  },
} as const;

const useStyles = makeStyles(styles);

const CustomInputTooltip = ({
  dataTestid,
  text,
  placement,
}: {
  dataTestid?: string;
  text: string;
  placement?: TooltipProps["placement"];
}) => {
  const classes = useStyles();

  const convertTextToHTML = (text: string) => {
    return { __html: text };
  };

  return (
    <Tooltip
      className={classes.CustomInputTooltip}
      title={<div dangerouslySetInnerHTML={convertTextToHTML(text)} />}
      placement={placement}
    >
      <Button
        data-testid={dataTestid}
        style={{
          background: "none",
          padding: 0,
          margin: 0,
          minWidth: 0,
          color: "inherit",
        }}
      >
        <span className="material-icons-outlined md-18">help_outline</span>
      </Button>
    </Tooltip>
  );
};

export default CustomInputTooltip;
